"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionsDataService = void 0;
const api_1 = require("../api");
class ConnectionsDataService {
    constructor({ client }) {
        this.apiVersion = api_1.apiVersion;
        this.client = client;
    }
    getMetrics(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.fetch(`/${this.apiVersion}/connections/${params.id}/metrics`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json",
                },
                body: params.data_plane_request,
            })).json();
        });
    }
    runConnectivityCheck(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.fetch(`/${this.apiVersion}/connectivity-check`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json",
                },
                body: params.data_plane_request,
            });
        });
    }
    /**
     * Scan and return all matching resources in an external system.
     * Requires a bearer token for this operation issued by the control plane API.
     *
     * @param params A scan external resources request request body.
     * @returns any A scan external resources response.
     * @returns Error An error has occurred.
     */
    scanExternalResources(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.fetch(`/${this.apiVersion}/external/scan-resources`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json",
                },
                body: params.data_plane_request,
            })).json();
        });
    }
    /**
     * Create given resources in an external system.
     * Requires a bearer token for this operation issued by the control plane API.
     *
     * @param params A create external resources request body.
     * @returns any A create external resources response.
     * @returns Error An error has occurred.
     */
    createExternalResources(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.fetch(`/${this.apiVersion}/external/create-resources`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json",
                },
                body: params.data_plane_request,
            })).json();
        });
    }
    postEvents(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = "events" in params
                ? JSON.stringify({ events: params.events })
                : params.data_plane_request;
            return (yield this.client.fetch(`/${this.apiVersion}/connections/${params.connection_id}/events-ui`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${params.auth_token}`,
                    "Content-Type": "application/json",
                },
                body,
            })).json();
        });
    }
}
exports.ConnectionsDataService = ConnectionsDataService;
exports.default = ConnectionsDataService;
